export default __webpack_public_path__ + "static/media/dots.2508e726.svg";